import { Link } from "react-router-dom";
import { PageTitle } from "../components/site/PageTitle";
import { useSite } from "../context/SiteContext";

export default function Policies() {
  const { settings: s = {} } = useSite();
  return (
    <div className="pb-20">
      <PageTitle badge="ASAP & Co." title="Policies" subtitle="Please review the following order, artwork, payment, turnaround, and pickup policies before placing a custom order." testId="policies-title" />
      <div className="mx-auto grid max-w-5xl gap-5 px-6 md:grid-cols-2">
        {(s.policies || []).map((p, i) => (
          <div key={i} className="panel p-6" data-testid={`policy-${i}`}>
            <h2 className="red-title text-2xl">{p.title}</h2>
            <ul className="mt-3 space-y-2 text-sm text-slate-300">
              {p.items.map((it, j) => <li key={j} className="flex gap-2"><span className="text-[#E5202A]">★</span>{it}</li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <h3 className="font-display text-3xl font-black uppercase">We Appreciate Your Business</h3>
        <p className="mt-2 text-sm text-slate-400">Thank you for supporting local custom printing. Contact: <a className="text-[#60A5FA]" href={`mailto:${s.email}`}>{s.email}</a></p>
        <Link to="/order" className="btn-red mt-6" data-testid="policies-start-order-button">Start Custom Order</Link>
      </div>
    </div>
  );
}
